<template>
  <div>
    <group-card title="Link DocuSign Template" icon="link">
      <form enctype="multipart/form-data">
        <div class="md-layout">
          <!-- Template Type -->
          <md-field >
            <label>Select a Template Type</label>
            <md-select v-model="template_type_id" name="template_type" required>
              <md-option :value="0" key="0" select="select">Select a Template Type</md-option>
              <md-option v-for="template_type in templates" :value="template_type.id" :key="template_type.id">
                {{ template_type.name }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-if="template_type_id">
            <label>Select DocuSign Template</label>
            <md-select v-model="docusign_template_id" name="template_type" required>
              <md-option :value="0" key="0" select="select">Select DocuSign Template</md-option>
              <md-option v-for="template_type in docusignTemplates" :value="template_type.id" :key="template_type.id">
                {{ template_type.name }}
              </md-option>
            </md-select>
          </md-field>

          <div v-if="template_type_id && docusign_template_id">
            <md-button class="md-primary" @click="linkTemplate">Save</md-button>
          </div>

        </div>
      </form>
      <md-dialog-alert
        :md-active.sync="alertMessage.status"
        md-title=" "
        :md-content="alertMessage.message" />
    </group-card>
  </div>
</template>
<script>
import {GroupCard} from "@/components";
import {ValidatedTextInput} from "@/components";

export default {
  components: {
    GroupCard,
    ValidatedTextInput
  },
  data() {
    return {
      template_type_id: '',
      docusign_template_id: '',
      docusignTemplates: [],
      alertMessage:{
        status: false,
        message: ''
      }
    }
  },
  props: {
    templates: {
      type: Array,
      required: true
    }
  },
  methods:{
    async getSavedTemplates(){
      let response = await axios.get('/api/v1/docusign/get_saved_templates');
      this.docusignTemplates = response.data;
    },
    async linkTemplate(){
      let response = await axios.get(`/api/v1/docusign/link_template/${this.template_type_id}/${this.docusign_template_id}`);
      if (response) {
        this.alertMessage.status = true;
        this.alertMessage.message = 'Template is linked with DocuSign Template';
        this.template_type_id = '';
        this.docusign_template_id = '';
      }
    }
  },
  created() {
    this.getSavedTemplates();
  }
}
</script>
